// extracted by mini-css-extract-plugin
module.exports = {"fontPrimary":"'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif","secondary":"rgb(239, 111, 83)","button":"g_T","active":"g_V"};